import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import adaptedImageUrl, { BASE_URL } from '../../config';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { LOCAL_STORAGE } from "../../context/LocalStorage";
import DataTableExtensions from "react-data-table-component-extensions";
import ModalDetails from "../Orders/ModalDetails";

export default function Refunds() {
    const [data, setData] = useState([]);
    const MySwal = withReactContent(Swal)
    const [showModal, setShowModal] = useState(false);
    const [idRowSelected, setIdRowSelected] = useState(null);

    let token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)
    const fetchData = (event) => {
        fetchWrapper()
          .doGet({
              url: "/all_refunds",
              onSuccess: async (response) => {
                  setData(response.data.refunds)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
        // axios({
        //     method: "get",
        //     url: BASE_URL + "/all_refunds",
        //     headers: {
        //         'Authorization': token
        //     },
        //     timeout: 1000
        // })
        //     .then(function (response) {
        //         console.log(response.data);
        //         if ((response.data.status = 200)) {
        //             setData(response.data.refunds)
        //         }
        //     })

        //     .catch(function (error) {
        //         console.log(error);
        //     });
    }

    useEffect(() => {
        fetchData()
    }, []);


    const CustomImage = ({ row }) => (
        <div>
            <img height="50px" width="50px" className="w-full  align-middle border-none shadow-lg"
                src={adaptedImageUrl(row.avatar_url) ?? null} />
        </div>
    );
    const handleActiveCheckboxChange = (event) => {
        var idCheck = event.target.value;
        MySwal.fire({
            title: <p>¿Seguro desea cambiar el estado del reembolso?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            onOpen: () => {

            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/active_desactive_refund_paid",
              body:{
                  refund_id: idCheck
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });

                // axios({
                //     method: "post",
                //     url: BASE_URL + "/active_desactive_refund_paid",
                //     data: {
                //         refund_id: idCheck
                //     },
                //     headers: {
                //         'Authorization': token
                //     },
                //     timeout: 5000,
                // })
                //     .then(
                //         function (response) {
                //             if (response.data.status == 200) {
                //                 fetchData()
                //                 Swal.fire(
                //                     'Confirmado!',
                //                     'Se ha cambiado el estado.',
                //                     'success'
                //                 )
                //             }
                //         }.bind(this)
                //     )
                //     .catch(function (error) {
                //         if (error.response) {
                //             console.log(error.message);
                //             // console.log(response.data.message);
                //             alert(response.data.message);
                //         } else if (error.request) {
                //             alert("Error de conexion");
                //         } else {
                //             // console.log(error.message);
                //             alert(error.message);
                //         }
                //     });


            }
        });
    }

    const handleActiveCheckboxIsAuto = (event) => {
        var idCheck = event.target.value;
        MySwal.fire({
            title: <p>¿Seguro desea cambiar el estado a reembolso automatico?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            onOpen: () => {

            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/active_desactive_is_auto_refund",
              body:{
                  is_automatic: idCheck
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });

                // axios({
                //     method: "post",
                //     url: BASE_URL + "/active_desactive_is_auto_refund",
                //     data: {
                //         is_automatic: idCheck
                //     },
                //     headers: {
                //         'Authorization': token
                //     },
                //     timeout: 5000,
                // })
                //     .then(
                //         function (response) {
                //             if (response.data.status == 200) {
                //                 fetchData()
                //                 Swal.fire(
                //                     'Confirmado!',
                //                     'Se ha cambiado el estado.',
                //                     'success'
                //                 )
                //             }
                //         }.bind(this)
                //     )
                //     .catch(function (error) {
                //         if (error.response) {
                //             console.log(error.message);
                //             // console.log(response.data.message);
                //             alert(response.data.message);
                //         } else if (error.request) {
                //             alert("Error de conexion");
                //         } else {
                //             // console.log(error.message);
                //             alert(error.message);
                //         }
                //     });


            }
        });
    }

    const editModal = (id) => {
        setIdRowSelected(id)
        setShowModal(true)
    }

    const columns = [
        
        {
            name: "ID de la Orden",
            selector: "order_id",
            sortable: true,
        },
        {
            name: "Usuario",
            selector: "user",
            sortable: true,
        },
        {
            name: "Monto a Reembolsar",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.refund_amount)}</>,
            sortable: true,
        },
        {
            name: "Estado solicitado",
            selector: "refund_state",
            sortable: true,
        },
        {
            name: "Rembolso automatico",
            cell: row => <label className="form-check form-switch"> <input className="form-check-input" value={row.id}
                checked={row.is_automatic == 1 ? true : false}
                type="checkbox"
                name="is_forever"
                onChange={handleActiveCheckboxIsAuto} /><span
                    className="slider round"> </span></label>,
        },
        {
            name: 'Reembolsado',
            cell: row => <label className="form-check form-switch"> <input className="form-check-input" value={row.id}
                checked={row.is_refund == 1 ? true : false}
                type="checkbox"
                onChange={handleActiveCheckboxChange} /><span
                    className="slider round"> </span></label>,
        },
        {
            name: 'Ver detalle',
            cell: row => <a onClick={() => editModal(row.order_id)}><i class="fas fa-eye"></i></a>,
        },
    ];

    const tableData = {
        columns,
        data
    };
    return (
        <>
            <ModalDetails
                showModal={showModal}
                setShowModal={setShowModal}
                id={idRowSelected}
                setId={setIdRowSelected}
                fetchData={fetchData}
            />
            <div className="row">
                <h1>Administracion de devoluciones</h1>
            </div>
            <DataTableExtensions {...tableData}>

                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    paginationPerPage={10}
                />
            </DataTableExtensions>

        </>
    );
}
